import 'rxjs/add/operator/zip';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../Constants';
import { GenericCategoryFilter } from './generic.category-filter';

export class GenericStaggerCheckboxCategoryFilter extends GenericCategoryFilter {

  private hasExtractedInfo = false;
  position: string;
  subname: string;
  constructor(obj?: GenericCategoryFilter) {
    super();
    if (obj) {
      Object.assign(this, obj);
      this.extractStaggerInfo();
    }
  }

  get title(): Observable<string> {
    if (!this.hasExtractedInfo) {
      this.extractStaggerInfo();
    }

    let prefix;
    let title;
    if (this.position === 'front') {
      prefix = this.translateService.get('FC.Stagger.Label.Front');
    } else {
      prefix = this.translateService.get('FC.Stagger.Label.Rear');
    }

    title = this.translateService.get(`FC.Filters.${this.subname}.title`);

    return prefix.zip(title, (prefix2, title2) => `${prefix2} - ${title2}`);
  }

  private extractStaggerInfo() {
    const categoryFilterStaggerPosition = this.name.match(Constants.STAGGER_REGEXP);
    if (!categoryFilterStaggerPosition) {
      throw new Error(`Invalid staggered category filter position: ${this.name}`);
    }
    this.subname = categoryFilterStaggerPosition[1];
    this.position = categoryFilterStaggerPosition[2].toLowerCase();
    this.hasExtractedInfo = true;
  }
}
